import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";
import { Trophy, ArrowLeft, Loader2 } from "lucide-react";

export default function Leaderboard() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/leaderboard").then((r) => setData(r.data)).catch(() => setData({ enabled: false, universities: [] }));
  }, []);

  const medal = (i) => (i === 0 ? "text-amber-500" : i === 1 ? "text-slate-400" : i === 2 ? "text-orange-400" : "text-slate-300");

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <button onClick={() => navigate("/")}><Logo /></button>
          <button onClick={() => navigate("/")} className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900"><ArrowLeft className="h-4 w-4" /> Home</button>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-12">
        <div className="text-center mb-10">
          <h1 className="text-3xl font-bold tracking-tight text-slate-900">Campus Leaderboard</h1>
          <p className="mt-2 text-slate-600">Schools growing fastest with Syllabify.</p>
        </div>
        {!data ? (
          <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-blue-600" /></div>
        ) : !data.enabled ? (
          <div className="rounded-xl border border-slate-200 bg-white p-10 text-center text-slate-500" data-testid="leaderboard-off">The leaderboard is currently turned off.</div>
        ) : data.universities.length === 0 ? (
          <div className="rounded-xl border border-slate-200 bg-white p-10 text-center text-slate-500" data-testid="leaderboard-empty">No campus signups yet — be the first to grow your school.</div>
        ) : (
          <div className="rounded-xl border border-slate-200 bg-white divide-y divide-slate-100" data-testid="leaderboard-list">
            {data.universities.map((u, i) => (
              <div key={u.name} className="flex items-center gap-4 px-5 py-4">
                <span className={`text-lg font-bold w-8 ${medal(i)}`}>{i < 3 ? <Trophy className="h-5 w-5" /> : i + 1}</span>
                <span className="flex-1 font-medium text-slate-900">{u.name}</span>
                <span className="text-slate-600">{u.students} student{u.students === 1 ? "" : "s"}</span>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
